import commonMapping from "@/mapping/common";

const mode_list = [
  { config: "access", value: "access", label: "access" },
  { config: "trunk", value: "trunk", label: "trunk" },
];

export const vlanProfile = {
  mode: mode_list,
  client_isolation: commonMapping.intToBoolean,
  network_isolation: commonMapping.intToBoolean,
};

export default vlanProfile;
